import { Box, styled } from '@mui/material';

const VIEW_AUDIENCE_CARD_HEADER_HEIGHT = 46;

export const AudienceCardHeader = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    height: VIEW_AUDIENCE_CARD_HEADER_HEIGHT,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between'
}));
